// extracted by mini-css-extract-plugin
export var columnList = "_j6-0";